import { render, staticRenderFns } from "./Task_ClassChange.vue?vue&type=template&id=a16bdb4a&scoped=true&"
import script from "./Task_ClassChange.vue?vue&type=script&lang=js&"
export * from "./Task_ClassChange.vue?vue&type=script&lang=js&"
import style0 from "./Task_ClassChange.vue?vue&type=style&index=0&id=a16bdb4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16bdb4a",
  null
  
)

export default component.exports